/** Narrow explicit analysis-only requests. Ambiguous or operational requests keep
 * the ordinary permission-checked flow; this is not an authorization source.
 */
export function conceptualConsultation(messages:any[]):boolean{
 const text=[...messages].reverse().find(m=>m?.role==='user')?.content;
 if(typeof text!=='string'||text.length>2000)return false;
 if(/\bnon\s+(?:solo|soltanto)\b|\b(?:catalogo|metadati|strumenti)\b/i.test(text))return false;
 if(/\b(?:crea|creami|prepara|preparami|configura|configurami|salva|salvami|modifica|modificami|invia|inviami|assegna|pianifica|registra)\b/i.test(text))return false;
 const hypothesis=/\b(?:assetto|esempio|ipotesi|schema|ragionare|ragioniamo|capire\s+come\s+impostare)\b/i.test(text);
 const noOperation=/\b(?:senza\s+(?:eseguire|operare|leggere|configurare|importare)|non\s+(?:leggere|creare|modificare|preparare)|solo\s+capire)\b/i.test(text);
 return hypothesis&&noOperation;
}
